export const OPTION_GROUPS_FRAME_ENUMS = {
  EN: 'en',
  AR: 'ar',
  ENGLISH: 'English',
  ARABIC: 'Arabic',
  ALL: 'all',
  AVAILABLE: 'avaliable',
  UNAVAILABLE: 'unavaliable',
};
